export const environment = {
  production: false,
  emailAPIUrl: 'https://wagtail.ropon.dev.cntb.arcticportal.org/api/v2',
};
